import { useForm } from 'react-hook-form';

export interface CommentFormInput {
    content: string;
}

const CommentForm = (defaultContent: string) => {
    const {
        control,
        handleSubmit,
        reset: resetForm,
        formState: { isValid, isDirty, isSubmitting },
    } = useForm<CommentFormInput>({
        mode: 'all',
        defaultValues: {
            content: defaultContent,
        },
    });

    return { control, handleSubmit, resetForm, isValid, isDirty, isSubmitting };
};

export default CommentForm;
